import { render, staticRenderFns } from "./AddCart.vue?vue&type=template&id=ff271ac6"
import script from "./AddCart.vue?vue&type=script&lang=js"
export * from "./AddCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports